import { useParameter } from '../../../shared';
import React from 'react';
import { useExport } from '../../../shared';

export function useExportSource(source: string | undefined | null) {
  const exportBuilder = useExport();
  React.useEffect(() => {
    exportBuilder.set('source', source)
  }, [source]);
}